import { Slide } from '@/components/core/Slide';

export const slide = () => {
  return (
    <Slide
      notes="Claude capabilities for coding and writing"
      transition="fade"
      networkBackground="full"
    >
      <div className="relative z-10 flex flex-col justify-center h-full px-24 py-8 text-left slide-scale-75">
        <h2 className="title">Claude</h2>

        <div className="grid grid-cols-2 gap-12 mt-8">
          <div className="space-y-4">
            <h3 className="text-3xl font-semibold mb-6">🔧 Coderen</h3>
            <div className="space-y-3">
              <p>• Best in class code schrijven</p>
              <p>• (Samen met Google Gemini 2.5 Pro)</p>
              <p>• Code runnen in Claude UI</p>
            </div>
          </div>

          <div className="space-y-4">
            <h3 className="text-3xl font-semibold mb-6">✍️ Schrijven</h3>
            <div className="space-y-3">
              <p>• Betere teksten dan ChatGPT</p>
              <p>• Stop met ChatGPT gebruiken!</p>
            </div>
          </div>
        </div>
      </div>
    </Slide>
  );
};
